export const IconMungSmall = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99996 16.3535C11.623 16.3535 12.1426 17.0829 13.6033 17.0829C15.0644 17.0829 15.9734 16.1103 15.9734 14.408C15.9734 12.7056 14.058 11.7938 13.2135 10.6383C12.3694 9.48319 11.7854 8.17578 9.99965 8.17578C8.21394 8.17578 7.62957 9.48319 6.78544 10.6383C5.94131 11.7935 4.02588 12.7054 4.02588 14.408C4.02588 16.1103 4.93487 17.0829 6.39596 17.0829C7.85705 17.0832 8.37656 16.3535 9.99996 16.3535Z"
        fill="#ED8432"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1819 2.526C14.1884 2.71736 14.7451 3.90966 14.4263 5.18994C14.1071 6.46994 13.033 7.35259 12.0271 7.1615C11.0209 6.97014 10.4638 5.77783 10.7827 4.49756C11.1018 3.21783 12.1759 2.3349 13.1819 2.526Z"
        fill="#ED8432"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.38383 2.526C5.3779 2.71736 4.8206 3.90966 5.13972 5.18994C5.45856 6.46994 6.53298 7.35259 7.53891 7.1615C8.54512 6.97014 9.10214 5.77783 8.78302 4.49756C8.4639 3.21783 7.39004 2.3349 6.38383 2.526Z"
        fill="#ED8432"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.93124 6.43094C1.97752 6.61194 1.44938 7.74254 1.75163 8.95571C2.05388 10.1692 3.07214 11.006 4.02618 10.8247C4.9799 10.6437 5.50804 9.51278 5.20547 8.29961C4.90322 7.08644 3.88496 6.24964 2.93124 6.43094Z"
        fill="#ED8432"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0685 6.43094C18.0222 6.61194 18.5507 7.74254 18.2481 8.95571C17.9458 10.1692 16.9273 11.006 15.9736 10.8247C15.0198 10.6437 14.4917 9.51278 14.7943 8.29961C15.0965 7.08644 16.1151 6.24964 17.0685 6.43094Z"
        fill="#ED8432"
      />
    </svg>
  );
};
